/* eslint-disable */
export default {
  removeParticipant: 'Deelnemer verwijderen',
  confirmStr1: 'Weet u zeker dat u',
  confirmStr2: 'wilt verwijderen uit deze oproep?',
  remove: 'Verwijderen',
  cancel: 'Annuleren',
  participants: 'Deelnemers',
  participant: 'Deelnemer',
  conferenceCall: 'Conference call',
  unknownNumber: 'Anoniem',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
